import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "下载受理订单", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Download = _resolveComponent("Download")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_avue_crud = _resolveComponent("avue-crud")!

  return (_ctx.init)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_avue_crud, {
          ref: "crud",
          data: _ctx.data.data,
          option: _ctx.option,
          page: _ctx.page,
          "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
          onOnLoad: _ctx.changePage
        }, {
          menu: _withCtx(({row}) => [
            (_ctx.role!='gh')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  link: "",
                  onClick: ($event: any) => (_ctx.downExcel(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Download)
                      ]),
                      _: 1
                    }),
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data", "option", "page", "onOnLoad"])
      ]))
    : _createCommentVNode("", true)
}